@import '../../../global/variables.scss';

/**
 * Exposed CSS variables
 *
 * @prop --nav-menu-icon-color: The color of the menu icon
 * @prop --nav-dropdown-bg-color: The background color of the dropdown
 * @prop --nav-menu-close-color: The color of the close icon
*/

:host {
  padding: $size-2 calc($size-2 * 2);

  @include md {
    padding: $size-2 calc($size-2 + 0.25rem);
  }
  @include sm {
    padding: $size-2 calc($size-2 - 0.375rem);
  }
}

p {
  margin: 0;
  padding: 0;
}

header {
  min-height: 7vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 0;
  z-index: 10;
  background: var(--nav-bg-color, $light-700);
  padding: 0 calc($size-2 + 0.25rem);

  &.align-left {
    flex-direction: row-reverse;
  }
  &.align-right {
    flex-direction: row;
  }

  & > span {
    display: flex;
    flex-direction: row;
    gap: $size-half;

    &.reverse {
      flex-direction: row-reverse;
    }
  }
}

section {
  background-color: var(--nav-dropdown-bg-color, $light);
  width: 100%;
  position: absolute;
  top: 7vh;
  z-index: 5;
  transform: translateY(calc(-100% - 8vh));
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: $size-half;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--nav-bg-color, $light-700);

  &.active {
    transform: translateY(0);
  }
}

.hamburger-menu {
  display: flex;
  align-items: center;

  & > .menu-icon {
    width: 1.5rem;
    height: 1.5rem;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    cursor: pointer;

    & > span {
      width: 1.5rem;
      height: 0.2rem;
      background-color: var(--nav-menu-icon-color, $orange-500);
      border-radius: 0.625rem;
      transition: all 0.3s linear;
    }

    &.active {
      span:nth-child(1) {
        transform-origin: center;
        transform: translateY(0.5rem) rotate(45deg);
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        transform-origin: center;
        transform: translateY(-0.5rem) rotate(-45deg);
      }
    }
  }
}

.search-bar {
  position: absolute;
  z-index: 5;
  right: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $light-700;
  gap: 1.25rem;
  padding: 0 calc($size-2 + 0.25rem);

  & > div {
    margin-bottom: -0.25rem;
  }
}

svg {
  path {
    fill: var(--nav-menu-close-color, $orange-500);
  }
}
